// extracted by mini-css-extract-plugin
export default {"container":"Popup_container__D-wHs","close-button":"Popup_close-button__Sshky"};